import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import path from 'ramda/src/path'
import pick from 'ramda/src/pick'
import pipe from 'ramda/src/pipe'

export default (onSelectAction, onSelectProps, moduleKey) => async (dispatch, getState) => {
	const state = getState()
	const formData = pipe(
		path(['form', moduleKey, 'formInputs']),
		pick(onSelectProps),
	)(state)

	const { body } = await dispatch(apiRequest(onSelectAction, formData))
	return body
}
